import { getCookieDomain } from "./cookie-helpers";

export const getCookie = (cookieKey: string): string | undefined => {
    if (!document.cookie) return undefined;

    const cookies: Record<string, string> = {};

    document.cookie.split(";").forEach((entry) => {
        const index = entry.indexOf("=");
        if (index === -1) return;

        const key = entry.slice(0, index).trim();
        const value = decodeURIComponent(entry.slice(index + 1));
        cookies[key] = value;
    });

    return cookies[cookieKey];
};

export const getCleanCookie = <T extends Record<string, any>>(cookies: T): T => {
    // Node-safe deep clone
    const copy = JSON.parse(JSON.stringify(cookies));

    for (const [, value] of Object.entries(copy)) {
        for (const key in value as any) {
            if (
                (value as any)[key] === "" ||
                (value as any)[key] === undefined ||
                (value as any)[key] === null
            ) {
                delete (value as any)[key];
            }
        }
    }

    return copy;
};

export const setCookies = (key: string, values: any, date?: Date) => {
    const encodedValue = encodeURIComponent(JSON.stringify(values));
    const cookieDomain = getCookieDomain();

    let cookie = `${key}=${encodedValue};path=/`;

    if (date) {
        cookie = `${key}=${encodedValue};expires=${date.toUTCString()};path=/;secure;httponly`;
    }

    // only add domain if NOT localhost
    if (!cookieDomain.includes("localhost")) {
        cookie = cookie.replace(";path=/", `;domain=${cookieDomain};path=/;secure;httponly`);
    }

    document.cookie = cookie;
};

export const setExpiringCookies = (cookies: Record<string, any>) => {
    const date = new Date();
    date.setHours(date.getHours() + 1);

    const cleaned = getCleanCookie(cookies);

    for (const [key, value] of Object.entries(cleaned)) {
        setCookies(key, value, date);
    }
};